import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit, ViewChild, ElementRef, EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { feather, heroicons, material } from 'app/mock-api/ui/icons/data';

@Component({
  selector: 'app-select-icon',
  standalone: true,
  imports: [
    CommonModule, MatIconModule, MatMenuModule, FormsModule
  ],
  templateUrl: './select-icon.component.html',
  styleUrl: './select-icon.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIconComponent),
      multi: true,
    },
  ],
})
export class SelectIconComponent implements ControlValueAccessor, OnInit, OnChanges {
  icons: string[] = [];
  visibleIcons: string[] = [];
  selectedIcon: string = 'heroicons_outline:home'
  private readonly _feather: any = feather;
  private readonly _heroicons: any = heroicons;
  private readonly _material: any = material;
  private loadBatch = 200;
  private loadedCount = 0;
  filter: string = '';

  @ViewChild('iconContainer') iconContainer!: ElementRef;
  @Input() defaultIcon = '';
  @Output() selected: EventEmitter<string> = new EventEmitter<string>()

  onChange: any = () => { };
  onTouched: any = () => { };

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  constructor(
    private _changeDetectorRef: ChangeDetectorRef
  ) { }
  
  ngOnInit() {
    this.loadIcons();
    setTimeout(() => {
      if (this.defaultIcon) {
        this.selectedIcon = this.defaultIcon;
      }
      
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('defaultIcon' in changes && this.defaultIcon) {
      this.selectedIcon = this.defaultIcon;
      this._changeDetectorRef.detectChanges();
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public Methods
  // -----------------------------------------------------------------------------------------------------

  loadIcons() {
    this.icons = [];
    this._feather.forEach((item: string) => {
      this.icons.push('feather:' + item);
    });
    this._heroicons.forEach((item: string) => {
      this.icons.push('heroicons_mini:' + item);
      this.icons.push('heroicons_outline:' + item);
      this.icons.push('heroicons_solid:' + item);
    });
    this._material.forEach((item: string) => {
      this.icons.push('mat_outline:' + item);
      this.icons.push('mat_solid:' + item);
    });
    this.loadMoreIcons();
  }

  loadMoreIcons() {
    const nextBatch = this.icons.filter(item => item.includes(this.filter)).slice(this.loadedCount, this.loadedCount + this.loadBatch);
    this.visibleIcons = [...this.visibleIcons, ...nextBatch];
    this.loadedCount += this.loadBatch;
  }

  onScroll(event: any) {
    const target = event.target;
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10) {
      this.loadMoreIcons();
    }
  }

  onIconSelect(icon: string) {
    this.selectedIcon = icon;
    this.onChange(this.selectedIcon);
    this.selected.emit(icon)
    this.filter = '';
    this.onSearch();
  }

  // get IconList() {
  //   return this.visibleIcons.filter(item => item.includes(this.filter));
  // }

  onSearch() {
    this.loadedCount = 0;
    this.visibleIcons = [];
    this.loadMoreIcons();
  }

  writeValue(value: string): void {
    this.selectedIcon = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}